import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltrosBusquedaVacante } from 'src/app/core/Interfaces/vacantes/filtros.interface';
import { Vacantes } from "src/app/core/Interfaces/vacantes/vacantes-resultado.interface";
import { SearchJobApiService } from 'src/app/core/services/search-job-api.service';
declare var bootstrap: any;
@Component({
  selector: 'app-search-job',
  standalone: false,
  templateUrl: './search-job.component.html',
  styleUrl: './search-job.component.scss'
})
export class SearchJobComponent implements OnInit {
  selectedId: string | null = '';
  indexJobSelected: number = 0;
  filters: FiltrosBusquedaVacante = new FiltrosBusquedaVacante();
  jobOpeningSelected: any = {};
  listJobOpening: Vacantes[] = [];
  allJobOpenings: Vacantes[] = [];
  @ViewChild('modalCompartir') modal!: ElementRef;
  enlace: string = '';
  mensaje: string = '';
  busquedaFinalizo: boolean = false;
  urlFilters: any = {};

  constructor(
    private route: ActivatedRoute, 
    private searchJobApiService: SearchJobApiService, 
    private router: Router, 
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log('Parámetros URL recibidos:', params);
      
      // Procesar parámetros de URL con decodificación
      this.processUrlParameters(params);
      
      if (this.filters.id) {
        this.selectedId = this.filters.id;
      }
      
      this.searchJobOpening();
    });
  }

  private processUrlParameters(params: any) {
    // Parámetros básicos
    this.filters.id = params['id'] || '';
    this.filters.job = params['job'] || undefined;
    
    // Filtros de búsqueda con decodificación URL
    this.filters.idPuesto = this.decodeUrlParameter(params['idPuesto']);
    this.filters.idUbicacion = this.decodeUrlParameter(params['idUbicacion']);
    this.filters.antiguedad = this.decodeUrlParameter(params['antiguedad']);
    this.filters.salario = this.decodeUrlParameter(params['sueldo']);

    // Preparar filtros para el componente filter-search-job
    this.urlFilters = {
      idPuesto: this.filters.idPuesto || '',
      idUbicacion: this.filters.idUbicacion || '',
      antiguedad: this.mapAntiguedadToSelectValue(this.filters.antiguedad),
      sueldo: this.filters.salario || ''
    };


  }

  // Método para mapear valores de antigüedad de URL a valores de select
  private mapAntiguedadToSelectValue(antiguedad: string | undefined): string {
    if (!antiguedad) return '0';
    
    switch (antiguedad.toLowerCase()) {
      case '1daysago':
      case '1dayago':
        return '1';
      case '3daysago':
      case '3dayago':
        return '2';
      case '7daysago':
      case '1weekago':
        return '3';
      case '15daysago':
      case '2weeksago':
        return '4';
      case '30daysago':
      case '1monthago':
        return '5';
      case 'morethan30days':
        return '6';
      default:
        // Si es un número directo, devolverlo
        const num = parseInt(antiguedad);
        if (!isNaN(num) && num >= 1 && num <= 6) {
          return antiguedad;
        }
        return '0';
    }
  }

  private decodeUrlParameter(param: string): string | undefined {
    if (!param) return undefined;
    
    try {
      // Decodificar parámetros URL (maneja caracteres especiales como %20, etc.)
      return decodeURIComponent(param);
    } catch (error) {
      console.warn('Error decodificando parámetro:', param, error);
      return param;
    }
  }

  // Método para aplicar filtros basados en parámetros de URL
  private applyUrlFilters(vacantes: any[]): any[] {
    console.log(`Aplicando filtros URL a ${vacantes.length} vacantes`, this.filters);
    
    const filteredVacantes = vacantes.filter(vacante => {
      let match = true;

      // Filtro por puesto/operador - buscar en description, descripcion_cliente, desc_puesto
      if (this.filters.idPuesto && this.filters.idPuesto.trim() !== '') {
        const searchTerm = this.filters.idPuesto.toLowerCase();
        const name = (vacante.name || '').toLowerCase();
        if (!name.includes(searchTerm)) {
          match = false;
        }
      }

      // Filtro por ubicación - buscar en direccion y ubicacion como LIKE
      if (this.filters.idUbicacion && this.filters.idUbicacion.trim() !== '') {
        const searchLocation = this.filters.idUbicacion.toLowerCase();
        const direccion = (vacante.direccion || '').toLowerCase();
        const ubicacion = (vacante.ubicacion || '').toLowerCase();
        
        if (!direccion.includes(searchLocation) && !ubicacion.includes(searchLocation)) {
          match = false;
        }
      }

      // Filtro por salario - verificar que el rango solicitado esté dentro del rango de la vacante
      if (this.filters.salario && this.filters.salario.trim() !== '') {
        const salarioFiltro = this.filters.salario;
        
        // Extraer números del filtro de salario (ej: "$15,000 - $20,000" -> [15000, 20000])
        const rangoSolicitado = this.extractSalaryRange(salarioFiltro);
        
        if (rangoSolicitado.min !== null && rangoSolicitado.max !== null) {
          // Extraer rangos de salario de la vacante
          const sueldoMinVacante = this.extractSalaryAmount(vacante.sueldo_min);
          const sueldoMaxVacante = this.extractSalaryAmount(vacante.sueldo_mx);
          
          // Verificar si hay overlap entre los rangos
          if (sueldoMinVacante !== null && sueldoMaxVacante !== null) {
            // El rango solicitado debe tener overlap con el rango de la vacante
            if (rangoSolicitado.max < sueldoMinVacante || rangoSolicitado.min > sueldoMaxVacante) {
              match = false;
            }
          }
        }
      }

      // Filtro por antigüedad (fecha de publicación)
      if (this.filters.antiguedad && this.filters.antiguedad.trim() !== '') {
        if (!vacante.createdOn) {
          console.warn('Vacante sin fecha de creación:', vacante.id, vacante.name);
          // Si no tiene fecha, la excluimos del filtro de antigüedad
          match = false;
        } else {
          const fechaCreacion = new Date(vacante.createdOn);
          const ahora = new Date();
          
          // Validar que la fecha sea válida
          if (isNaN(fechaCreacion.getTime())) {
            console.warn('Fecha de creación inválida:', vacante.createdOn, 'para vacante:', vacante.id);
            match = false;
          } else {
            const diasDiferencia = Math.floor((ahora.getTime() - fechaCreacion.getTime()) / (1000 * 3600 * 24));
            
            let maxDias = 0;
            // Mapear valores de antigüedad con más opciones
            switch (this.filters.antiguedad.toLowerCase()) {
              case '1daysago':
              case '1dayago':
              case '1': 
                maxDias = 1; 
                break;
              case '3daysago':
              case '3dayago':
              case '2': 
                maxDias = 3; 
                break;
              case '7daysago':
              case '1weekago':
              case '3': 
                maxDias = 7; 
                break;
              case '15daysago':
              case '2weeksago':
              case '4': 
                maxDias = 15; 
                break;
              case '30daysago':
              case '1monthago':
              case '5': 
                maxDias = 30; 
                break;
              case 'morethan30days':
              case '6':
                maxDias = 999; // Más de 30 días, se considera válido siempre
                break;
            }
            

            
            // Solo filtrar si se especificó un límite de días válido
            if (maxDias > 0 && maxDias < 999 && diasDiferencia > maxDias) {
              match = false;
            }
            // Para "más de 30 días", no hay restricción adicional
          }
        }
      }

      return match;
    });
    
    console.log(`Filtros aplicados. Vacantes resultantes: ${filteredVacantes.length}`);
    return filteredVacantes;
  }

  // Método auxiliar para extraer rango de salario del filtro
  private extractSalaryRange(salarioText: string): { min: number | null, max: number | null } {
    try {
      // Buscar patrones como "$15,000 - $20,000" o "15000-20000"
      const numbers = salarioText.match(/[\d,]+/g);
      if (numbers && numbers.length >= 2) {
        const min = parseInt(numbers[0].replace(/,/g, ''));
        const max = parseInt(numbers[1].replace(/,/g, ''));
        return { min, max };
      } else if (numbers && numbers.length === 1) {
        const amount = parseInt(numbers[0].replace(/,/g, ''));
        return { min: amount, max: amount };
      }
    } catch (error) {
      console.warn('Error al extraer rango de salario:', salarioText, error);
    }
    return { min: null, max: null };
  }

  // Método auxiliar para extraer cantidad de salario
  private extractSalaryAmount(salarioText: string): number | null {
    if (!salarioText || salarioText.trim() === '') return null;
    
    try {
      // Extraer números del texto, removiendo comas y símbolos
      const match = salarioText.match(/[\d,]+/);
      if (match) {
        return parseInt(match[0].replace(/,/g, ''));
      }
    } catch (error) {
      console.warn('Error al extraer cantidad de salario:', salarioText, error);
    }
    return null;
  }

  private showFiltersInfo(): void {
    console.log('Filtros aplicados:', {
      puesto: this.filters.idPuesto,
      ubicacion: this.filters.idUbicacion,
      antiguedad: this.filters.antiguedad,
      salario: this.filters.salario,
      resultados: this.listJobOpening.length
    });
  }


  findJobOpening(): void {
    const vacante = this.listJobOpening.find(v => v._id === this.selectedId);
    if (vacante) {
      console.log('findJobOpening() Vacante encontrada para ID seleccionado:', this.selectedId, vacante);
      this.jobOpeningSelected = vacante._source;
      this.indexJobSelected = this.listJobOpening.findIndex(v => v._id === this.selectedId);
    } else {
      this.jobOpeningSelected = {};
      this.indexJobSelected = 0;
    }
  }
  searchJobOpening(): void {
    this.resetSelection();
    
    console.log('🔍 Iniciando búsqueda con filtros:', this.filters);
    
    this.searchJobApiService.getVacantesPorFiltro(this.filters).subscribe({
      next: (data) => {
        console.log('✅ Datos recibidos de Appian:', data);
        console.log('✅ Tipo de datos:', typeof data);
        console.log('✅ Es array?:', Array.isArray(data));
        console.log('✅ Cantidad de elementos:', Array.isArray(data) ? data.length : 'N/A');
        
        let _vacantes: any[] = [];
        
        // Si la respuesta es un array directo
        if (Array.isArray(data)) {
          _vacantes = data;
          console.log('✅ Procesando como array directo, cantidad:', _vacantes.length);
        } 
        // Si la respuesta tiene estructura hits (Elasticsearch-like)
        else if (data && data.hits && Array.isArray(data.hits.hits)) {
          _vacantes = data.hits.hits.map((hit: any) => hit._source || hit);
          console.log('✅ Procesando estructura hits, cantidad:', _vacantes.length);
        }
        // Si la respuesta tiene una propiedad data
        else if (data && data.data && Array.isArray(data.data)) {
          _vacantes = data.data;
          console.log('✅ Procesando estructura data, cantidad:', _vacantes.length);
        }
        // Si es un objeto único
        else if (data && typeof data === 'object') {
          _vacantes = [data];
          console.log('✅ Procesando como objeto único');
        }
        // Si está vacío o no reconocido
        else {
          console.warn('⚠️ Respuesta no reconocida o vacía');
          _vacantes = [];
        }

        console.log('📊 Vacantes antes de aplicar filtros URL:', _vacantes.length);

        // Aplicar filtros de URL y transformar datos
        _vacantes = this.applyUrlFilters(_vacantes);
        console.log('📊 Vacantes después de aplicar filtros URL:', _vacantes.length);
        
        this.transformAndSortJobData(_vacantes);

        // Manejar selección según contexto
        this.handleJobSelection();
        
        this.showFiltersInfo();
        this.finalizeBusqueda();
      },
      error: (error) => {
        console.error('❌ Error al buscar vacantes:', error);
        console.error('❌ Status:', error.status);
        console.error('❌ Mensaje:', error.message);
        console.error('❌ Error completo:', error);
        this.busquedaFinalizo = true;
      }
    });
  }

  private resetSelection(): void {
    this.listJobOpening = [];
    this.jobOpeningSelected = {};
    this.selectedId = '';
    this.indexJobSelected = 0;
  }

  private transformAndSortJobData(vacantes: any[]): void {
    this.allJobOpenings = vacantes
    .filter(item => item.description && item.description.trim() !== '')
    .map(item => ({
      _index: '',
      _id: item.id?.toString() || '',
      _score: 1,
      _source: item,
      enterpriseName: item.empresaId,
      name: item.name
    })).sort((a, b) => b._id.localeCompare(a._id));

    this.listJobOpening = [...this.allJobOpenings];
    
    // Si no hay resultados después del filtrado, limpiar selección
    if (this.listJobOpening.length === 0) {
      this.jobOpeningSelected = {};
      this.selectedId = '';
      this.indexJobSelected = 0;
    }
  }

  private handleJobSelection(): void {
    if (this.filters.id) {
      // Buscar por ID específico
      this.selectedId = this.filters.id;
      this.findJobOpening();
      const foundJob = this.allJobOpenings.find(v => v._id === this.selectedId);
      this.listJobOpening = foundJob ? [foundJob] : [];
    } else {
      // Seleccionar el primer resultado filtrado o dejar vacío
      this.selectFirstFilteredJob();
    }
  }

  private selectFirstFilteredJob(): void {
    if (this.listJobOpening.length > 0) {
      this.selectedId = this.listJobOpening[0]._id;
      console.log('selectFirstFilteredJob() Vacante encontrada para ID seleccionado:', this.selectedId);
      this.jobOpeningSelected = this.listJobOpening[0]._source;
      this.indexJobSelected = 0;
    } else {
      this.jobOpeningSelected = {};
      this.selectedId = '';
      this.indexJobSelected = 0;
    }
  }

  private finalizeBusqueda(): void {
    this.cdr.detectChanges();
    setTimeout(() => {
      this.busquedaFinalizo = true;
    }, 1000);
  }

  onFiltrosChange(filtros: any): void {
    this.listJobOpening = this.allJobOpenings.filter(job => {
      const vac = job._source;
      
      // Filtro por nombre
      if (filtros.name?.trim() && 
          !vac.name?.toLowerCase().includes(filtros.name.toLowerCase()) &&
          !vac.description?.toLowerCase().includes(filtros.name.toLowerCase())) {
        return false;
      }

      // Filtro por ubicación
      if (filtros.ubicacion?.trim()) {
        const ubicacionTexto = this.getUbicacion(vac.ubicacion).toLowerCase();
        if (!ubicacionTexto.includes(filtros.ubicacion.toLowerCase())) {
          return false;
        }
      }

      // Filtro por sueldo mínimo
      if (filtros.sueldo_min > 0 && !vac.ocultar_sueldo) {
        const sueldoMin = parseInt((vac.sueldo_min || '0').replace(/[^0-9]/g, ''));
        if (sueldoMin < filtros.sueldo_min) return false;
      }

      // Otros filtros
      if (filtros.categoria?.trim() && vac.categoria !== filtros.categoria) return false;
      if (filtros.horario_trabajo > 0 && vac.horario_trabajo !== filtros.horario_trabajo) return false;
      if (filtros.escolaridad > 0 && vac.escolaridad !== filtros.escolaridad) return false;

      return true;
    });

    // Debug: Mostrar cuántos resultados se encontraron después del filtrado
    console.log(`Filtros aplicados. Resultados: ${this.listJobOpening.length}`);
    
    // Aplicar la misma lógica de selección que en searchJobOpening
    this.selectFirstFilteredJob();
    this.cdr.detectChanges();
  }
  jobOpeningClick(index: number, id: number): void {
    this.indexJobSelected = index;
    this.selectedId = id.toString();
    
    // Buscar y asignar la vacante seleccionada
    const vacante = this.listJobOpening[index];
    if (vacante && vacante._source) {
      console.log('jobOpeningClick() Vacante encontrada para ID seleccionado:', this.selectedId, vacante);
      this.jobOpeningSelected = vacante._source;
    } else {
      this.jobOpeningSelected = {};
    }
  }

  goToJobApply(): void {
    localStorage.setItem('jobSelected', JSON.stringify(this.jobOpeningSelected));
    this.router.navigate(['/postulacion', this.selectedId]);
  }

  openShareModal(): void {
    this.enlace = `${window.location.origin}/buscador?id=${this.selectedId}`;
    new bootstrap.Modal(this.modal.nativeElement).show();
  }

  copiarEnlace(): void {
    navigator.clipboard.writeText(this.enlace).then(() => {
      this.mensaje = 'Enlace copiado ✅';
      setTimeout(() => this.mensaje = '', 2000);
    });
  }
  
  decodeHtml(text: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  }

  getFormattedText(text?: string): string {
    if (!text) return '';
    const decoded = this.decodeHtml(text);
    return decoded.replace(/(\r\n|\n|\r)/g, '<br>');
  }

  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  // Funciones de ayuda para mapear los datos de Appian
  getUbicacion(ubicacionJson?: string): string {
    if (!ubicacionJson) return 'Ubicación no especificada';
    
    try {
      const ubicacion = JSON.parse(ubicacionJson);
      const parts = [];
      
      if (ubicacion.ciudad) parts.push(ubicacion.ciudad);
      if (ubicacion.region) parts.push(ubicacion.region);
      if (ubicacion.pais) parts.push(ubicacion.pais);
      
      return parts.length > 0 ? parts.join(', ') : 'Ubicación no especificada';
    } catch (error) {
      return ubicacionJson || 'Ubicación no especificada';
    }
  }

  getHorarioTrabajo(horarioId?: number): string {
    if (!horarioId) return 'No especificado';
    
    const horarios: { [key: number]: string } = {
      1: 'Tiempo completo',
      2: 'Medio tiempo',
      3: 'Por horas',
      4: 'Fin de semana',
      5: 'Nocturno'
    };
    return horarios[horarioId] || 'No especificado';
  }

  getLugarTrabajo(lugarId?: number): string {
    if (!lugarId) return 'No especificado';
    
    const lugares: { [key: number]: string } = {
      1: 'Presencial',
      2: 'Remoto',
      3: 'Híbrido'
    };
    return lugares[lugarId] || 'No especificado';
  }

  getEscolaridad(escolaridadId?: number): string {
    if (!escolaridadId) return 'No especificado';
    
    const escolaridades: { [key: number]: string } = {
      1: 'Primaria',
      2: 'Secundaria',
      3: 'Preparatoria',
      4: 'Técnico',
      5: 'Licenciatura',
      6: 'Posgrado'
    };
    return escolaridades[escolaridadId] || 'No especificado';
  }

  getTipoContratacion(tipoId?: number): string {
    if (!tipoId) return 'No especificado';
    
    const tipos: { [key: number]: string } = {
      1: 'Indefinido',
      2: 'Temporal',
      3: 'Por proyecto',
      4: 'Prácticas'
    };
    return tipos[tipoId] || 'No especificado';
  }
  isJson(str: string): boolean {
    if (!str) return false;
    str = str.trim();
    return (str.startsWith('{') || str.startsWith('['));
  }

  formatoMoneda(value?: string | number): string {
    if (value === null || value === undefined || value === '') return '';

    let str = String(value).trim();

    // Rango: "1500 - 1250" o "$1300000 -1800"
    if (str.includes('-')) {
      return str
        .split('-')
        .map(part => this.formatoMoneda(part))
        .join(' - ');
    }

    // Quita todo salvo dígitos y punto
    str = str.replace(/[^0-9.]/g, '');
    if (!str) return '';

    const num = parseFloat(str);
    if (isNaN(num)) return '';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD', // o 'MXN'
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  }


}
